var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExcluirAnuncio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 312,
    height: 208,
    viewBox: "0 0 312 208",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 312,
    height: 208,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3884_160782)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M198.238 53.34C198.238 53.34 192.448 26.74 176.828 17.67C175.708 17.02 174.468 18.33 175.208 19.4C176.588 21.41 178.108 24.2 179.138 27.78C179.458 28.9 178.248 29.83 177.238 29.23C169.948 24.93 161.518 22.5 152.548 22.55C144.088 22.6 136.128 24.85 129.178 28.78C129.038 28.86 125.388 30.7 121.428 35.7L70.4584 118.99C70.3584 119.15 70.2784 119.32 70.1984 119.49C70.1084 119.69 70.0184 119.89 69.9284 120.09C68.3284 124.24 71.3484 128.96 76.0384 128.96H177.328C182.028 128.96 185.038 124.24 183.438 120.09C183.348 119.89 183.258 119.69 183.168 119.49C183.088 119.32 183.008 119.16 182.908 118.99L141.238 50.9C139.318 47.76 141.008 43.67 144.578 42.8L144.698 42.77C145.288 42.63 145.818 42.23 146.018 41.66C146.998 38.9 140.428 38.25 135.078 39.8C134.858 39.86 134.648 39.86 134.448 39.82C133.918 38.95 134.198 37.82 135.088 37.32C137.798 35.78 144.238 33.04 155.488 32.7C172.298 32.2 187.218 41.23 196.278 54.5C197.068 55.66 198.788 54.64 198.228 53.34H198.238Z",
    fill: "#FD9D00",
    stroke: "#5731FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127.387 116.95C125.687 116.95 124.117 116.39 122.857 115.45C120.997 114.06 119.797 111.85 119.797 109.35C119.797 105.15 123.197 101.75 127.387 101.75C130.307 101.75 132.847 103.4 134.117 105.81C134.677 106.87 134.987 108.07 134.987 109.34C134.987 113.53 131.587 116.93 127.387 116.93V116.95Z",
    fill: "white",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M134.958 64.4L134.018 72.42L131.698 92.22C131.578 93.26 130.698 94.04 129.658 94.04H124.968C123.928 94.04 123.048 93.25 122.928 92.22L119.828 64.39C119.778 63.93 119.798 63.49 119.878 63.07C120.258 61.05 122.038 59.48 124.218 59.48H130.578C133.218 59.48 135.268 61.79 134.968 64.42L134.958 64.4Z",
    fill: "white",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M225.809 184.27C225.809 184.69 225.529 185.1 224.999 185.49C221.269 188.23 205.119 190.29 185.759 190.29C166.399 190.29 148.999 188.06 146.149 185.16C145.859 184.88 145.719 184.58 145.719 184.28C145.719 184.08 145.779 183.89 145.909 183.68C147.879 180.63 164.969 178.26 185.759 178.26C206.549 178.26 222.409 180.47 225.339 183.35C225.649 183.65 225.809 183.96 225.809 184.27Z",
    fill: "#5731FF",
    stroke: "#5731FF",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M230.74 102.49L218.86 183L218.57 184.58C215.45 186.6 201.95 188.12 185.76 188.12C169.57 188.12 155.02 186.47 152.64 184.33L152.44 183.24L140.52 102.49H230.74Z",
    fill: "#8CD1BF",
    stroke: "#5731FF",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M185.63 106.05C210.543 106.05 230.74 104.456 230.74 102.49C230.74 100.524 210.543 98.9301 185.63 98.9301C160.716 98.9301 140.52 100.524 140.52 102.49C140.52 104.456 160.716 106.05 185.63 106.05Z",
    fill: "#5731FF",
    stroke: "#5731FF",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3884_160782",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 141,
    y: 31,
    width: 103,
    height: 75
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M243.09 53.33L177.01 31L157.5 99.69C147.59 100.32 141.88 101.22 141 101.98C142.53 103.29 158.44 105.04 185.55 105.04C212.66 105.04 228.58 103.29 230.1 101.98C229.51 101.48 226.8 100.91 222.15 100.4L243.08 53.33H243.09Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3884_160782)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.794 70.1618L182.376 52.7189C180.278 51.8952 177.91 52.9278 177.087 55.0252L152.198 118.403C151.374 120.501 152.407 122.869 154.504 123.692L198.922 141.135C201.02 141.959 203.388 140.926 204.211 138.829L229.1 75.4508C229.924 73.3534 228.891 70.9855 226.794 70.1618Z",
    fill: "white",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.277 77.3399L180.078 60.3759L167.157 93.2797L210.355 110.244L223.277 77.3399Z",
    fill: "#8CD1BF",
    stroke: "#5731FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.961 102.43L172.011 103.35C172.221 103.44 172.201 103.75 171.981 103.81L169.831 104.47C169.741 104.5 169.671 104.58 169.661 104.68L169.421 106.91C169.401 107.14 169.101 107.21 168.971 107.03L167.681 105.19C167.621 105.11 167.521 105.07 167.431 105.09L165.231 105.55C165.011 105.6 164.841 105.34 164.981 105.16L166.331 103.36C166.391 103.28 166.401 103.17 166.351 103.09L165.241 101.14C165.131 100.94 165.321 100.71 165.541 100.78L167.661 101.51C167.751 101.54 167.861 101.51 167.921 101.44L169.431 99.78C169.581 99.61 169.861 99.72 169.861 99.95L169.821 102.2C169.821 102.3 169.881 102.39 169.971 102.43H169.961Z",
    fill: "#8CD1BF",
    stroke: "#5731FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.562 105.8L180.612 106.72C180.822 106.81 180.802 107.12 180.582 107.18L178.432 107.84C178.342 107.87 178.272 107.95 178.262 108.05L178.022 110.28C178.002 110.51 177.702 110.58 177.572 110.4L176.282 108.56C176.222 108.48 176.122 108.44 176.032 108.46L173.832 108.92C173.612 108.97 173.442 108.71 173.582 108.53L174.932 106.73C174.992 106.65 175.002 106.54 174.952 106.46L173.842 104.51C173.732 104.31 173.922 104.08 174.142 104.15L176.262 104.88C176.352 104.91 176.462 104.88 176.522 104.81L178.032 103.15C178.182 102.98 178.462 103.09 178.462 103.32L178.422 105.57C178.422 105.67 178.482 105.76 178.572 105.8H178.562Z",
    fill: "#8CD1BF",
    stroke: "#5731FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.138 102.061C207.334 101.562 200.316 98.3398 191.464 94.8635C182.612 91.3872 175.277 88.9734 175.081 89.472C174.885 89.9706 181.903 93.193 190.755 96.6692C199.607 100.146 206.942 102.559 207.138 102.061Z",
    fill: "#5731FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.647 95.38C208.647 95.38 207.567 99.63 205.717 100.8C205.607 100.87 205.467 100.88 205.337 100.83L202.607 99.76C202.467 99.71 202.367 99.59 202.347 99.44C202.317 99.28 202.327 99.05 202.437 98.7L208.657 95.38H208.647Z",
    fill: "#5731FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.408 83.5C178.408 83.5 176.308 87.35 176.868 89.47C176.898 89.6 176.998 89.7 177.118 89.75L179.848 90.82C179.988 90.87 180.138 90.86 180.258 90.77C180.388 90.67 180.548 90.5 180.698 90.17L178.398 83.5H178.408Z",
    fill: "#5731FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.527 93.37C208.207 96.6 207.017 98.54 206.557 99.24C206.437 99.43 206.217 99.53 205.987 99.5C204.487 99.31 181.187 90.95 177.557 88.34C177.377 88.21 177.277 87.99 177.317 87.76C177.457 86.93 177.907 84.69 179.137 81.43C179.137 81.43 179.327 80.37 179.767 79.48C180.097 78.81 180.767 77.98 181.067 77.63C181.167 77.52 181.287 77.43 181.417 77.36C182.167 77.02 184.827 75.84 186.087 75.35C186.087 75.35 188.427 73.48 191.647 71.87C191.817 71.78 192.017 71.76 192.207 71.79C193.137 71.97 195.077 72.11 199.637 73.9C204.427 75.78 205.717 76.91 206.517 77.41C206.677 77.51 206.807 77.66 206.877 77.84C208.137 81.2 208.587 84.17 208.587 84.17C209.177 85.38 210.317 88.06 210.637 88.82C210.697 88.96 210.727 89.11 210.717 89.25C210.697 89.71 210.627 90.77 210.407 91.5C210.127 92.45 209.537 93.35 209.537 93.35L209.527 93.37Z",
    fill: "#FD9D00",
    stroke: "#5731FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.639 83.44L208.769 83.49C208.919 83.55 209.099 83.47 209.159 83.32L209.429 82.62C209.429 82.62 209.589 82.19 210.009 82.34C210.429 82.49 212.149 83.19 211.719 84.29C211.399 85.12 208.969 84.12 208.969 84.12L208.749 84.03L208.629 83.43L208.639 83.44Z",
    fill: "#FD9D00",
    stroke: "#5731FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.469 83.98L180.879 79.27C180.879 79.27 180.479 79.47 180.279 80.23C180.249 80.36 180.259 80.49 180.299 80.61L180.619 81.48C180.729 81.79 180.929 82.06 181.179 82.26L183.129 83.84C183.129 83.84 183.559 84.21 184.229 84.28C184.529 84.31 184.819 84.25 185.099 84.13L185.469 83.97V83.98Z",
    fill: "white",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.427 84.9701L182.027 80.4501",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.238 90.96L209.808 90.63C209.808 90.63 209.968 91.05 209.588 91.74C209.528 91.85 209.428 91.95 209.308 92L208.488 92.42C208.198 92.57 207.868 92.64 207.548 92.61L205.048 92.45C205.048 92.45 204.478 92.43 203.948 92.02C203.708 91.84 203.528 91.59 203.408 91.32L203.248 90.95L203.238 90.96Z",
    fill: "white",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.867 91.03L208.157 90.71",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.57 84.1899C208.57 84.1899 208.81 85.0699 209.05 86.4999C209.12 86.9099 209.07 87.3399 208.91 87.7199C208.69 88.2299 208.35 89.0199 207.98 89.7899",
    stroke: "#5731FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.928 93.71L205.608 93.76C205.608 93.76 205.078 93.65 203.838 94.27C202.588 94.88 201.488 95.59 201.488 95.59C201.488 95.59 200.498 96.42 201.918 97.01C203.338 97.6 205.348 97.58 205.348 97.58C205.348 97.58 206.438 97.62 207.288 96.07L208.148 94.57C208.148 94.57 208.698 93.76 207.928 93.72V93.71Z",
    fill: "#5731FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.577 74.77L186.447 74.72C186.297 74.66 186.217 74.49 186.277 74.33L186.547 73.63C186.547 73.63 186.727 73.21 186.317 73.03C185.907 72.85 184.177 72.2 183.737 73.29C183.407 74.11 185.867 75.04 185.867 75.04L186.087 75.13L186.577 74.77Z",
    fill: "#FD9D00",
    stroke: "#5731FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.68 78.1C205.68 78.1 201.98 76.01 199.22 74.93C196.46 73.85 192.33 72.86 192.33 72.86C191.08 73.34 188.86 74.98 187.89 75.73C187.69 75.89 187.75 76.21 187.99 76.28C193.33 77.82 195.11 78.4 197.49 79.33C199.87 80.26 201.56 81.05 206.53 83.56C206.76 83.68 207.02 83.48 206.98 83.23C206.77 82.02 206.27 79.31 205.68 78.11V78.1Z",
    fill: "#5731FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.568 95.19C197.638 95.15 185.888 90.16 185.198 89.55C183.968 88.46 184.698 85.2599 185.098 84.6299C185.388 84.1799 186.778 84.2999 187.928 84.5599C188.378 84.6599 188.778 84.78 189.078 84.9L199.888 89.1399C200.958 89.5599 203.128 90.93 202.988 91.66C202.858 92.39 201.208 95.23 199.568 95.19Z",
    fill: "#5731FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.077 75.36C186.077 75.36 185.297 75.84 184.157 76.72C183.827 76.97 183.577 77.32 183.437 77.71C183.247 78.24 182.967 79.04 182.707 79.86",
    stroke: "#5731FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.067 82.7799L181.737 84.3899C181.737 84.3899 182.197 84.6699 182.697 85.9699C183.197 87.2699 183.527 88.5399 183.527 88.5399C183.527 88.5399 183.687 89.8199 182.247 89.2899C180.807 88.7599 179.347 87.3699 179.347 87.3699C179.347 87.3699 178.527 86.6599 178.957 84.9399L179.337 83.2599C179.337 83.2599 179.487 82.2999 180.077 82.7899L180.067 82.7799Z",
    fill: "#5731FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.73 88.92C194.54 89.39 194.01 89.63 193.53 89.44C193.25 89.33 193.05 89.1 192.98 88.83C192.93 88.64 192.93 88.44 193.01 88.24C193.2 87.76 193.73 87.53 194.21 87.72C194.48 87.83 194.68 88.05 194.76 88.31C194.82 88.5 194.82 88.72 194.74 88.92H194.73Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.314 89.4404L189.876 90.5573C189.817 90.7064 189.89 90.8747 190.039 90.9333L195.066 92.9071C195.215 92.9657 195.383 92.8923 195.442 92.7432L195.88 91.6262C195.939 91.4771 195.866 91.3088 195.716 91.2503L190.69 89.2764C190.541 89.2179 190.373 89.2913 190.314 89.4404Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.398 84.84L197.388 85.62C197.688 85.74 197.978 85.89 198.238 86.08C198.708 86.42 199.668 87.03 201.188 87.63C203.438 88.51 206.428 89.59 207.048 90.58",
    stroke: "#5731FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.428 84.85L193.438 84.07C193.138 83.95 192.828 83.87 192.498 83.83C191.928 83.76 190.798 83.55 189.288 82.96C187.038 82.08 184.118 80.83 182.988 81.14",
    stroke: "#5731FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.889 85.14L200.269 84.11C200.109 84.05 200.069 83.9 200.199 83.86L200.939 83.66C201.029 83.64 201.139 83.65 201.239 83.69L203.859 84.72C204.019 84.78 204.059 84.93 203.929 84.97L203.189 85.17C203.099 85.19 202.989 85.18 202.889 85.14Z",
    fill: "#5731FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.599 79.92L192.219 80.95C192.379 81.01 192.509 80.93 192.439 80.81L192.029 80.16C191.979 80.08 191.889 80.02 191.789 79.98L189.169 78.95C189.009 78.89 188.879 78.97 188.949 79.09L189.359 79.74C189.409 79.82 189.499 79.88 189.599 79.92Z",
    fill: "#5731FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.707 74.05L193.688 77C193.688 77.25 193.847 77.47 194.087 77.55C195.227 77.93 196.158 78.27 197.208 78.68C197.368 78.74 197.527 78.81 197.677 78.87C197.917 78.96 198.157 78.75 198.087 78.5L197.158 74.95C197.108 74.76 196.967 74.61 196.777 74.55C195.857 74.25 194.907 73.97 194.087 73.75C193.887 73.7 193.697 73.84 193.697 74.05H193.707Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.2 75.43L199.28 79.2C199.35 79.44 199.52 79.63 199.75 79.73C200.85 80.21 202.05 80.77 203.74 81.61C203.92 81.7 204.1 81.5 204 81.33L201.09 76.45C200.99 76.29 200.85 76.16 200.67 76.08C200.07 75.82 199.05 75.4 198.47 75.17C198.31 75.11 198.15 75.26 198.19 75.42L198.2 75.43Z",
    fill: "white"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M197.16 160.22C191.2 164.93 184.41 169.92 177.02 174.72",
    stroke: "#5731FF",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M194.862 149.15C184.832 157.27 172.082 166.5 157.922 174.22",
    stroke: "#5731FF",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M194.582 136.34C184.362 144.96 170.482 155.5 154.762 164.28",
    stroke: "#5731FF",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M187.203 129.41C178.223 136.82 166.793 145.37 153.973 152.92",
    stroke: "#5731FF",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M178.371 123.61C170.771 129.67 161.741 136.25 151.801 142.31",
    stroke: "#5731FF",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M170.909 116.6C168.089 118.86 165.069 121.19 161.879 123.54",
    stroke: "#5731FF",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M157.41 166.25C161.02 168.91 164.86 171.59 168.87 174.22",
    stroke: "#5731FF",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M151.801 149.15C161.701 157.17 174.251 166.26 188.181 173.92",
    stroke: "#5731FF",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M153.77 137.74C164.5 146.66 178.88 157.34 195.02 165.97",
    stroke: "#5731FF",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M158.699 128.77C168.249 136.71 180.689 146.04 194.689 154.08",
    stroke: "#5731FF",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M160.25 116.96C169.22 124.64 181.34 134.1 195.22 142.52",
    stroke: "#5731FF",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M220.49 105.02L210.34 186.7",
    stroke: "#5731FF",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3884_160782"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 174.16,
    height: 173.79,
    fill: "white",
    transform: "translate(69 17)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcluirAnuncio);
export default __webpack_public_path__ + "static/media/excluir-anuncio.358a7e86.svg";
export { ForwardRef as ReactComponent };